export default {"src":"/_next/static/media/doctor.f7f37e12.svg","height":490,"width":686};